import { Briefcase, Scale, GraduationCap, Home, Sparkles, Megaphone } from "lucide-react";

const ACCENT = "#BEF264";

const SEGMENTS = [
  { Icon: Briefcase, label: "B2B service providers", copy: "Capture enquiries, assign follow-up and track consultations and proposals." },
  { Icon: Scale, label: "Professional services", copy: "Manage quotation requests, consultations and prospective customer information." },
  { Icon: GraduationCap, label: "Training and education businesses", copy: "Manage programme enquiries, applications, registrations and follow-up." },
  { Icon: Home, label: "Property businesses", copy: "Track property enquiries, customer requirements and appointments." },
  { Icon: Sparkles, label: "Cleaning and home-service businesses", copy: "Capture service requests and follow up with prospective customers." },
  { Icon: Megaphone, label: "Businesses running Google and Meta Ads", copy: "Connect advertising enquiries to CRM records and a structured follow-up process." },
];

export default function SalesWhoFor() {
  return (
    <section id="use-cases" aria-labelledby="use-cases-heading" data-testid="sales-whofor-section" className="relative py-20 sm:py-28 bg-white">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-3xl mb-12">
          <div className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-zinc-50 px-3.5 py-1.5 text-[11px] tracking-[0.14em] uppercase text-zinc-600 font-semibold mb-6">
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: "#0B1120" }} /> Lead generation websites for businesses
          </div>
          <h2 id="use-cases-heading" className="font-display text-4xl sm:text-5xl font-black tracking-[-0.03em] leading-[1.04] text-zinc-900">
            Built for Businesses That Depend on Customer Enquiries
          </h2>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SEGMENTS.map(({ Icon, label, copy }, i) => (
            <div key={label} data-testid={`sales-usecase-${i}`} className="rounded-2xl border border-zinc-200 bg-white p-5 transition-[border-color,box-shadow] hover:border-zinc-300 hover:shadow-[0_16px_40px_-24px_rgba(0,0,0,0.25)]">
              <div className="h-10 w-10 rounded-xl bg-[#0B1120] flex items-center justify-center"><Icon className="h-5 w-5" style={{ color: ACCENT }} /></div>
              <h3 className="mt-4 font-display text-lg font-black text-zinc-900 leading-snug">{label}</h3>
              <p className="mt-1.5 text-sm text-zinc-600 leading-relaxed">{copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
